
<span class="oneRootNode">
    <PopupAlert v-if="enablePopupAlert" />

    <div
        class="container-fluid fixed-top"
        id="header_small"
        v-if="showSmallHeader"
    >
        <div class="row justify-content-center no-gutters">
            <div class="col col-12 col-md-11">
                <div class="row">
                    <div class="col col-12 col-lg-9 offset-lg-3  header_small_inner">
                        <slot name="header_small"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div
        class="container-fluid"
        ref="toprow"
        :class="{ 'has-backroute': !!this.$slots.back }"
    >
        <div class="row justify-content-center">
            <div class="col col-12 col-md-11">
                <div class="row">
                    <div class="d-none d-lg-block col col-3">
                        <div class="left_menu_inner_sticky">
                            <Logo class="menu_logo"
                                v-on="logoOnClick ? {click: logoOnClick} : {}"
                                :class="{clickable: logoOnClick}"
                            />

                            <div id="back-button">
                                <slot name="back"></slot>
                            </div>

                            <slot name="menu"></slot>
                        </div>
                    </div>

                    <div class="col col-12 col-lg-9">
                        <div class="row justify-content-end">
                            <div
                                id="header"
                                class="col col-12"
                                :class="{
                                    'has-breadcrumbs': !!this.$slots
                                        .breadcrumbs,
                                }"
                            >
                                <div id="breadcrumbs">
                                    <slot name="breadcrumbs"></slot>
                                </div>

                                <slot name="header"></slot>
                            </div>

                            <div class="col col-12">
                                <slot name="content"></slot>

                                <Footer v-if="showFooter" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</span>
